"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wait = wait;
exports.getRandomValue = getRandomValue;
exports.generateId = generateId;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./communication"), exports);
tslib_1.__exportStar(require("./formatter"), exports);
tslib_1.__exportStar(require("./frame"), exports);
function wait(timeout) {
    if (timeout === void 0) { timeout = 1500; }
    return new Promise(function (resolve) { return setTimeout(function () { return resolve(true); }, timeout); });
}
function getRandomValue(list) {
    if (!list.length)
        return "";
    if (list.length === 1)
        return list[0];
    var index = Math.floor(Math.random() * list.length);
    return list[index];
}
function generateId(_a) {
    var _b = _a === void 0 ? { length: 24 } : _a, length = _b.length;
    var values = "abcdefghijklmonpqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890-_";
    var token = "";
    for (var i = 0; i < length; i++) {
        token += values[Math.floor(Math.random() * values.length)];
    }
    return "".concat(Date.now().toString(16)).concat(token);
}
